// Vendor Program v3 UAT recon (F9) — TanStack Query hooks over the vendor
// qualification stages. The read registers under the co-located key factory;
// the upsert invalidates the vendor's stage list. Toasts + error rendering
// happen in the calling component.

import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  vendorQualificationsApi,
  type UpdateVendorQualificationStageRequest,
} from "@/api/portfolioAdmin/vendorQualificationsApi";
import { vendorQualificationKeys } from "@/hooks/portfolioAdmin/vendorQualificationKeys";

export function useVendorQualificationStages(vendorId: string | undefined) {
  return useQuery({
    queryKey: vendorQualificationKeys.list(vendorId ?? ""),
    queryFn: () => vendorQualificationsApi.list(vendorId!),
    enabled: !!vendorId,
  });
}

export function useUpsertVendorQualificationStage(vendorId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: {
      stageCode: string;
      body: UpdateVendorQualificationStageRequest;
    }) => vendorQualificationsApi.upsert(vendorId, vars.stageCode, vars.body),
    onSuccess: () => {
      void qc.invalidateQueries({
        queryKey: vendorQualificationKeys.list(vendorId),
      });
    },
  });
}
